module.exports = __webpack_public_path__ + "static/media/homet1.9b82b117.svg";